import React from "react";
import { SUPPLY_CHAIN_COPY, partnerTypeLabel, visibleDirections } from "../../constants/supplyChain";
import "./SupplyChainPartners.css";

const MATCH_LABELS = {
    dyc: { text: "On DYC", className: "scp-badge--dyc" },
    existing_lead: { text: "Existing lead", className: "scp-badge--lead" },
    new_lead: { text: "New lead", className: "scp-badge--new" },
};

/**
 * Read-only supply chain for admin views (Pending Approvals, License Management).
 * partners: [{ id, direction, partnerName, partnerType, productTypes, onDyc?, match?, disputed? }]
 * `match` (pending approvals) overrides the On DYC / lead chip.
 */
export default function PartnerSummary({ profile, partners = [], operationType }) {
    const directions = profile ? visibleDirections(profile) : ["upstream", "downstream"];
    return (
        <div className="scp-summary">
            {operationType && (
                <p className="scp-summary-line">
                    <strong>{SUPPLY_CHAIN_COPY.operationType.label}:</strong> {operationType}
                </p>
            )}
            {directions.map((direction) => {
                const list = partners.filter((p) => p.direction === direction);
                return (
                    <div key={direction} className="scp-summary-list">
                        <strong>{SUPPLY_CHAIN_COPY.lists[direction].label}</strong>
                        {list.length === 0 ? (
                            <p className="scp-hint">None</p>
                        ) : (
                            <ul>
                                {list.map((p) => {
                                    const match = MATCH_LABELS[p.match] || (p.onDyc ? MATCH_LABELS.dyc : { text: "CRM lead", className: "scp-badge--lead" });
                                    return (
                                        <li key={p.id}>
                                            <span className="scp-summary-name">{p.partnerName}</span>
                                            <span className={`scp-badge ${match.className}`}>{match.text}</span>
                                            {p.disputed && <span className="scp-badge scp-badge--warn">Disputed</span>}
                                            <span className="scp-hint">
                                                {[partnerTypeLabel(p.partnerType) || "Type not set", (p.productTypes || []).join(", ")]
                                                    .filter(Boolean)
                                                    .join(" · ")}
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
